import React from "react"
import { Route, Routes } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import "./App.css"
import Navbar from "./Components/Navbar"
import RegisterPage from "./Pages/Register"
import LoginPage from "./Pages/Login"
import Home from "./Pages/Home"
import { useAuth } from "./Contexts/AuthContext"
import retrieveSession from "./utils/auth/retrieveSession"
import CreateEditExpenseGroup from "./Pages/CreateEditExpenseGroup"
import ExpenseGroups from "./Pages/ExpenseGroups"
import AddExpense from "./Pages/AddExpense"
import ExpenseGroup from "./Pages/ExpenseGroup"
import DeleteExpenseGroup from "./Pages/DeleteExpenseGroup"
import Logout from "./Pages/Logout"

function App() {
  const { login, logout } = useAuth()

  React.useEffect(() => {
    retrieveSession(login, logout)
  }, [])

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" Component={Home} />
        <Route path="/login" Component={LoginPage} />
        <Route path="/register" Component={RegisterPage} />
        <Route path="/logout" Component={Logout} />
        <Route
          path="create-edit-expense-group"
          Component={CreateEditExpenseGroup}
        />

        <Route path="expense-groups" Component={ExpenseGroups} />

        <Route path="add-expense/:group_id" Component={AddExpense} />
        <Route path="expense-group/:id" Component={ExpenseGroup} />
        <Route
          path="delete-expense-group/:group_id"
          Component={DeleteExpenseGroup}
        />
      </Routes>

      <ToastContainer />
    </>
  )
}

export default App
